import useResetTimeout from "../useResetTimeout";
import { useEffect, useState } from "react";
import axios from "axios";
import useErrorHandler from "../userErrorHandler";

const useGet = (
  path: string,
  errorTitle: string,
  defaultValue: any,
  dependencies?: any[],
  config?: object,
  runCondition?: () => boolean,
  validateResponse?: (v: any) => boolean
) => {
  const resetTimeout = useResetTimeout();
  const [value, setValue] = useState<any>(defaultValue);
  const [loading, setLoading] = useState<boolean>(false);
  const setError = useErrorHandler();

  useEffect(() => {
    if (!runCondition || runCondition()) {
      (async () => {
        try {
          setLoading(true);
          const fullConfig = config ? { ...config } : {};
          const response = await axios.get(path, fullConfig);
          setValue(response.data);
          setLoading(false);
          resetTimeout();
        } catch (err) {
          if (err.message === "Network Error") {
            document.location.href = "/";
          }
          setLoading(false);
          setError(errorTitle, err);
        }
      })();
    }
  }, dependencies || []);

  const resultValid = !validateResponse || validateResponse(value);

  useEffect(() => {
    if (!resultValid) {
      setError(
        errorTitle + ". The server appears to be sending the wrong data-type.",
        value
      );
    }
  }, [value, resultValid]);

  return { value: resultValid ? value : defaultValue, loading };
};

export default useGet;
